module.exports = __webpack_public_path__ + "static/media/sf-logo-horizontal.9704efef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sf-logo-horizontal.png
// module id = 222
// module chunks = 0